import { query, serviceQueries } from '@estee/elc-service-bus';
import { IAppConfig } from '@estee/elc-universal-utils';
import { computed } from 'mobx';
import { Config, IOrderTrackingConfig } from '../domain/entities/Config';
import { brandIdValPath, regionIdValPath } from '../utils/Constants';

export class ConfigRepository {
    public config: Config;

    constructor(config: IAppConfig) {
        this.config = new Config(config);
    }

    public getDefaultConfigs = async () => {
        const config = await query(serviceQueries.GET_CONFIG, [
            'orderTracking',
            brandIdValPath,
            regionIdValPath
        ]);
        config.brand = { id: config[brandIdValPath] };
        config.region = { id: config[regionIdValPath] };
        delete config[brandIdValPath];
        delete config[regionIdValPath];
        this.config.updateConfig(config);
    };

    @computed
    public get orderTrackingConfig() {
        return this.config.config?.orderTracking as IOrderTrackingConfig;
    }
}
